exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-menu[data-v-6761113a] {\n  background-color: #424242 !important;\n  position: relative;\n  color: #FFF;\n}\n.text-step[data-v-6761113a] {\n  font-size: 1.2rem;\n}\n.text-step.active[data-v-6761113a] {\n  color: #31aadd;\n}", ""]);

// exports
